export enum Age {
    Under35 = "under35",
    Between35And38 = "between35and38",
    Over38 = "over38",
}